import { render, staticRenderFns } from "./FontBigIcon.vue?vue&type=template&id=46eaa06f&"
import script from "./FontBigIcon.vue?vue&type=script&lang=js&"
export * from "./FontBigIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports